<template>
	<div>
		<!-- <v-navigation-drawer
            v-model="fileUploadDialog"
            app
            relative
            right
            width="46%"
            overlay-opacity="0"
            class="drawer-shadow">
            <v-card tile class="drawer-content pb-12">
                <v-card-title class="sansation_subtitle primary lighten-2 info--text font-weight-bold py-6 d-flex justify-space-between">
                    <div class="d-inline">
                        Upload Resolution Deliverables
                    </div>
                    <div class="d-inline">
                        <v-btn 
                            icon
                            outlined
                            color="info"
                            elevation="1"
                            @click="closeUploadDeliverables">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </div>
                </v-card-title>
                <v-card-text class="pt-3">
                    <UploadResolutionDeliverables 
                        :projectData="projectDetails"
                        :moduleKey="projectDetails.modinfo.module_key"
						:resolutionId="resolutionId"
                        :parentProjectId="projectDetails.project_id"
                        :userId="projectDetails.user_id"
                        :isDeliverable="true"
						@pullProjectDelivs="pullProjectDelivs"
                        @triggerUserFeedback="uploadFeedback"
                        @closeUploadDeliverables="closeUploadDeliverables"
                    />
                </v-card-text>
            </v-card>
        </v-navigation-drawer> -->

        <div v-if="projectDetails.modinfo.module_key === 'entity-maintenance-program'" class="d-flex justify-space-between mb-12 py-0">
            <div v-if="projectDetails.modinfo.module_key === 'entity-maintenance-program'" class="d-inline mb-12 py-0" style="width: 25%;">
                <div class="sansation label_medium info--text d-block mb-3 pt-1">Annual Report Filing Data</div>
                <div class="d-block pl-3 bordered_block">
                    <v-select
                        v-model="projectDetails.annual_report_type"
                        :items="report_type_options_list"
                        label="Annual Report Type"
                        class="d-block"
                        @change="updateAnnualReportType(projectDetails)">
                    </v-select>

                    <!-- <div class="label_medium info--text mt-3">Annual Report Filing Date</div> -->
                    <div v-if="!showCompletedDate">
                        <v-menu
                            v-model="projectDetails.annual_report_filing_date_menu"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            min-width="290px">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="formattedAnnualFilingDate"
                                    append-outer-icon="mdi-calendar"
                                    label="Annual Report Filing Date"
                                    class="pr-5"
                                    color="primary darken-1"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on">
                                </v-text-field>
                            </template>
                            <v-date-picker
                                v-model="formattedAnnualFilingDate"
                                :disabled="projectDetails.is_archived"
                                @input="projectDetails.annual_report_filing_date_menu = false; updateAnnualReportFilingDate(projectDetails)">
                            </v-date-picker>
                        </v-menu>

                        <v-select
                            v-model="projectDetails.annual_report_filing_status"
                            :items="annual_report_filing_status_list"
                            label="Annual Report Filing Status"
                            class="d-block"
                            @change="updateAnnualReportFilingStatus(projectDetails)">
                        </v-select> 
                    </div>
                    <div v-else class="label_medium primary--text text--darken-3 d-block ml-2">
                        {{ formatDate(projectDetails.annual_report_filing_date) }}
                    </div>
                </div>
                

                <div class="sansation label_medium info--text d-block mt-12 mb-3 pt-1">Recommended Annual Meeting Date</div>
                <div class="d-block pl-3">
                    <div v-if="!showCompletedDate">
                        <v-menu
                            v-model="projectDetails.recommended_annual_meeting_date_menu"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            min-width="290px">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="formattedRecommendedAnnualMeetingDate"
                                    append-outer-icon="mdi-calendar"
                                    class="mt-n2 pr-5"
                                    color="primary darken-1"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on">
                                </v-text-field>
                            </template>
                            <v-date-picker
                                v-model="formattedRecommendedAnnualMeetingDate"
                                :disabled="projectDetails.is_archived"
                                @input="projectDetails.recommended_annual_meeting_date_menu = false; updateRAMD(projectDetails)">
                            </v-date-picker>
                        </v-menu>
                    </div>
                    <div v-else class="label_medium primary--text text--darken-3 d-inline ml-2 pl-3">
                        {{ formatDate(projectDetails.recommended_annual_meeting_date) }}
                    </div>
                </div>
            </div>
        
            <div class="d-inline mb-12 py-0 px-4" style="width: 66%;">
                <div class="d-flex align-center mb-4">
                    <div class="mb-0 mr-3 sansation label_medium info--text d-inline">Foreign Qualification Filing Data</div>
                    <span v-if="foreignQualificationStatusNote" class="caption error--text text--darken-1">
                        {{ foreignQualificationStatusNote }}
                    </span>
                </div>
                <v-data-table 
                    v-if="showForeignQualificationTable"
                    :items="foreignQualificationData.fq_data" 
                    :headers="headers" 
                    class="ma-0 pa-0 "
                    multi-sort>
                    <template v-slot:[`item.fq_filing_status`]="{ item }">
                        <v-autocomplete
                            v-model="item['fq_filing_status']"
                            :items="annual_report_filing_status_list"
                            hide-details
                            rounded
                            class="fq-filing-status-select form-text-size mt-n3"
                            @change="updateForeignQualificationFilingStatus(item, $event)">
                        </v-autocomplete>
                    </template>
                </v-data-table>
            </div>
        </div>

        <div v-if="entityFilingModules.includes(projectDetails.modinfo.module_key)" class="mb-12 py-0" style="width: 25%;">
            <div class="sansation label_medium info--text d-block mb-3 pt-1">Entity Filing Status</div>
            <div class="px-3 d-block d-flex align-center justify-start info--text label_medium">
                <v-select
                    v-model="projectDetails.entity_filing_status"
                    :items="entity_filing_status_list"
                    label="Entity Filing Status"
                    color="primary darken-1"
                    append-outer-icon="mdi-file-star-four-points"
                    @change="updateEntityFilingStatus(projectDetails)">
                </v-select> 
            </div>
        </div>

	</div>
</template>

<script>
	import axios from "axios";
	import Cookie from 'js-cookie';
	import appUrls from '../helpers/environment'

	export default {
        name: 'EmpFilingData',

		components: {
			// UploadResolutionDeliverables,
		},

		props: {
			projectDetails: Object,
            showCompletedDate: Boolean,
            entityFilingModules: Array,
            entity_filing_status_list: Array,
            report_type_options_list: Array,
            annual_report_filing_status_list: Array,
			formatThisDate: Function,
            thisProjectDetail: Function,
			triggerUserFeedback: Function,
		},

		data() {
			return {
				headers: [
					{ text: 'State', 	        value: 'state-display', 	    align: 'start',  sortable: true },
					{ text: 'Report Type', 		value: 'report-type-display', 	align: 'start',  sortable: true },
					{ text: 'Filing Due Date', 	value: 'filing_due_date',	    align: 'start',  sortable: true },
					{ text: 'Filing Status', 	value: 'fq_filing_status',      align: 'end',    sortable: true, width: '20%' },
					// { text: 'Actions',			value: '', 					    align: 'end', 	 sortable: false },
				],
				buyerQuestionnaire_dialog: false,
				thisBuyer: {},
				resolutionDrawer: false,
				showStatusMenu: false,
				statusMenuPosition: { x: 0, y: 0 },
				selectedStatusItem: null,
				fileUploadDialog: false,
				resolutionId: null,
				resolutionData: {},
				exportingAnswersByProject: {},
                foreignQualificationData: []
			}
		},

		computed: {
            foreignQualificationStatusNote () {
                const fqDataAsk = this.foreignQualificationData && this.foreignQualificationData.fq_data_ask
                const fqData = this.foreignQualificationData && Array.isArray(this.foreignQualificationData.fq_data)
                    ? this.foreignQualificationData.fq_data
                    : []

                if (fqDataAsk === 'no' && fqData.length === 1 && fqData[0] === 'None') {
                    return '(client reports no foreign qualifications)'
                }

                if (fqDataAsk === 'np' && fqData.length === 1 && fqData[0] === 'Not Provided') {
                    return '(client has not answered foreign qualification questions)'
                }

                return ''
            },

            showForeignQualificationTable () {
                return !this.foreignQualificationStatusNote
            },

            formattedAnnualFilingDate: {
                get() {
                    return this.projectDetails.annual_report_filing_date ? this.formatMenuDate(this.projectDetails.annual_report_filing_date) : ''
                },
                set(value) {
                    this.projectDetails.annual_report_filing_date = value
                    return this.formatMenuDate(value);
                }
            },

            formattedRecommendedAnnualMeetingDate: {
                get() {
                    return this.projectDetails.recommended_annual_meeting_date ? this.formatMenuDate(this.projectDetails.recommended_annual_meeting_date) : ''
                },
                set(value) {
                    this.projectDetails.recommended_annual_meeting_date = value
                    return this.formatMenuDate(value);
                }
            },
		},

		created () {
			// console.log(this.projectDetails.dlvs);
		},

        mounted () {
            this.getQuestionnaireData();
        },

		methods: {
            updateForeignQualificationFilingStatus: async function ( item, selectedStatus ) {
                this.$set(item, 'fq_filing_status', selectedStatus)
                try {
                    const update_project_rs = await axios.put(`${appUrls.api}/api/admin/update_foreign_qualification_filing_status`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                        project: {
                            project_id: this.projectDetails.project_id,
                            foreign_qualification_filing_status: selectedStatus
                        }
                    })
                    
                    this.$emit('triggerUserFeedback', true, update_project_rs.data.message);
                } catch ( error ) {
                    console.log(error);
                }
            },

            updateAnnualReportFilingStatus: async function (project) {
                try {
                    const update_project_rs = await axios.put(`${appUrls.api}/api/admin/update_annual_report_filing_status`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                        project: {
                            project_id: project.project_id,
                            annual_report_filing_status: project.annual_report_filing_status
                        }
                    })

                    this.$emit('triggerUserFeedback', true, update_project_rs.data.message);
                } catch ( error ) {
                    console.log(error);
                }
            },

            updateAnnualReportType: async function (project) {
                try {
                    const update_project_rs = await axios.put(`${appUrls.api}/api/admin/update_annual_report_type`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                        project: {
                            project_id: project.project_id,
                            annual_report_type: project.annual_report_type
                        }
                    })

                    this.$emit('triggerUserFeedback', true, update_project_rs.data.message);
                } catch ( error ) {
                    console.log(error);
                }
            },

            updateAnnualReportFilingDate: async function ( data ) {
                try {
                    const project_update = await axios.put(`${appUrls.api}/api/admin/project_afd`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                        user_id: data.user_id,
                        project_id: data.project_id,
                        afd: data.annual_report_filing_date
                    })
                
                    if ( project_update.data.outcome ) {
                        this.$feedback.success( project_update.data.message );

                        setTimeout(() => {
                            this.thisProjectDetail(project_update.data.project_id, data.user_id);
                        }, 2000)
                    }
                } catch ( error ) {
                    console.log(error);
                }
            },

            updateRAMD: async function ( data ) {
                try {
                    const est_rec_annual_mtg_date = await axios.put(`${appUrls.api}/api/admin/project_ramd`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                        user_id: data.user_id,
                        project_id: data.project_id,
                        ramd: data.recommended_annual_meeting_date
                    })

                    if ( est_rec_annual_mtg_date.data.outcome ) {                        
                        this.$feedback.success( est_rec_annual_mtg_date.data.message );

                        setTimeout(() => {
                            this.thisProjectDetail(est_rec_annual_mtg_date.data.project_id, data.user_id);
                        }, 2000)
                    }
                } catch ( error ) {
                    console.log(error);
                }
            },

            updateEntityFilingStatus: async function ( project ) {
                try {
                    const update_entity_filing_status_rs = await axios.put(`${appUrls.api}/api/admin/update_entity_filing_status`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                        project: {
                            project_id: project.project_id,
                            entity_filing_status: project.entity_filing_status
                        }
                    })

                    if( update_entity_filing_status_rs.data.outcome ){
                        // this.updateProject = {}
                        this.$emit('triggerUserFeedback', true, update_entity_filing_status_rs.data.message);
                    } else {
                        this.$emit('triggerUserFeedback', true, update_entity_filing_status_rs.data.message, 'accent' );
                    }

                } catch ( error ) {
                    console.log(error);
                }
            },

			formatDateTime: function ( date_to_format ) {
                const options = {
                    month: '2-digit', 
                    day: '2-digit', 
                    year: 'numeric'
                }

                const formatted_date = this.formatThisDate(date_to_format, options);
                return formatted_date ? formatted_date : '';
            },

			uploadFeedback ( show_feedback, message ) {
				this.$emit('triggerUserFeedback', show_feedback, message);
			},

			openResolutionDrawer ( item ) {
				this.resolutionData = item
				this.resolutionDrawer = true
			},

			closeNavigationDrawer () {
				this.resolutionDrawer = false
			},

			openStatusMenu ( event, item ) {
				this.selectedStatusItem = item
				this.statusMenuPosition.x = event.clientX
				this.statusMenuPosition.y = event.clientY
				this.showStatusMenu = true
			},

            getQuestionnaireData: async function () {
                const response = await axios.get(`${appUrls.api}/api/admin/pull_questionnaire_data/${this.projectDetails.project_id}`, {
					headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
				})

                if ( response.data.outcome ) {
                    this.foreignQualificationData = response.data.questionnaire_data
				} else {
					this.$emit('triggerUserFeedback', true, "There was a problem during the process of retrieving the foreign qualification data for this project.", 'accent' );
				}
            },

			getStatusMetaData: function ( status_val ) {
				return this.projectStatuses.find( status => status.value == status_val ) ? this.projectStatuses.find( status => status.value == status_val ) : {}
			},

			closeUploadDeliverables: function () {
				this.fileUploadDialog = false 
			},

			changeStatus: async function (item, selectedStatusOption) {
				if (!item) {
					this.showStatusMenu = false
					return
				}

				if (item.status == selectedStatusOption) {
					this.showStatusMenu = false
					this.selectedStatusItem = null
					this.$emit('triggerUserFeedback', true, 'This project\'s status is already set to this option.', 'accent' );
					return
				}

				this.projectStatuses.find(status => {
					if (status.value == selectedStatusOption) {
						item.status 				= status.value
						item.status_internal_label 	= status.internal_label
						item.status_color 			= status.status_color
						item.status_progress_color 	= status.status_progress_color
						item.status_text_color 		= status.status_text_color
					}
				})

				this.updateResolutionStatus( item, selectedStatusOption )
				this.showStatusMenu = false
				this.selectedStatusItem = null
				this.$emit('triggerUserFeedback', true, 'Project status updated successfully.');
				this.$emit('getSubProjects', this.projectDetails.project_id)
			},

			updateResolutionStatus: async function ( resolution, new_status = 'complete' ) {
				const project = { ...resolution }
				project.status = new_status

				const update_project_status_rs = await axios.put(`${appUrls.api}/api/admin/update_project_status`, {
					headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
					project
				})

				if ( update_project_status_rs.data.outcome ) {
					resolution.close_date = update_project_status_rs.data.project.close_date
					this.$emit('triggerUserFeedback', true, update_project_status_rs.data.message);
				} else {
					this.$emit('triggerUserFeedback', true, "There was a problem during the process of completing the resolution for this project.", 'accent' );
				}
			},

			uploadResolutionDeliverables: function ( item ) {
				this.resolutionId = item.project_id
				this.fileUploadDialog = true
			},

			exportAnswers: async function ( projectDetails ) {
				const projectId = projectDetails.project_id
				this.$set(this.exportingAnswersByProject, projectId, true)
				
				try {	
					const export_questionnaire = await axios.post(`${appUrls.api}/api/admin/export_data`, {
						headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
						moduleKey: projectDetails.module_key,
						projectId: projectDetails.project_id,
						userId: projectDetails.user_id,
						parentProjectId: projectDetails.parent_project_id
					})
				
					if (export_questionnaire.data.outcome) {
						this.$feedback.success( export_questionnaire.data.message );

						const this_fileData = Buffer.from(export_questionnaire.data.buf, 'base64');
						const this_fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
						const this_fileName = export_questionnaire.data.basic_data.file_name + '.' + export_questionnaire.data.basic_data.output_type;

						const this_blob = new Blob([this_fileData], { type: this_fileType });
						saveAs(this_blob, this_fileName);
					} else {
						this.$emit('triggerUserFeedback', true, 'There was a problem during the process of exporting the answers for this project.', 'accent');
					}
				} catch (error) {
					console.log(error);
				} finally {
					this.$set(this.exportingAnswersByProject, projectId, false)
				}
			},

			buyerQuestionnaire( buyer ) {
				this.thisBuyer = {}
				this.thisBuyer = buyer;
				this.thisBuyer.buyer_id = buyer.user_id
				this.thisBuyer.is_secondary = false
				this.thisBuyer.project_id = buyer.project_id

				setTimeout(() => {
					this.buyerQuestionnaire_dialog = true;
				}, 1000)
			},

			closeQuestionnaire: function () {
				this.thisBuyer = {}
				this.buyerQuestionnaire_dialog = false;
			},

            formatMenuDate: function ( thisDate ) {
                if (!thisDate) return '';

                return new Date(thisDate).toISOString().split('T')[0]
            },

            formatDate: function ( date_to_format ) {
                const options = {
                    month: '2-digit', 
                    day: '2-digit', 
                    year: 'numeric'
                }

                const formatted_date = this.formatThisDate(date_to_format, options);
                return formatted_date ? formatted_date : '';
            },
		},
	}
</script>

<style scoped>
    >>> .v-data-table .v-data-table__wrapper > table > thead > tr > th {
        padding: 0 1em 0 1em !important;
        font-size: small !important;
        /* color: #333 !important; */
        margin: 0 !important;
        height: 36px !important;
        /* border-top: 1px solid #EDEDED !important; */
    }
    >>> .v-data-table .v-data-table__wrapper > table > tbody > tr > td {
        padding: .8em 1em .8em 1em !important;
        margin: 0 !important;
        font-size: small !important;
        cursor: pointer !important;
    }
    .form-text-size {
        font-size: small !important;
    }
	.drawer-shadow {
        z-index: 2000;
        box-shadow: -6px 0 12px rgba(0, 0, 0, 0.15);
    }
    .drawer-content {
        height: 100%; /* Full height of the drawer */
        overflow-y: auto; /* Allow vertical scrolling */
        background-color: whitesmoke !important;
    }
    /* Hide scrollbar but allow scrolling */
    .drawer-content::-webkit-scrollbar {
        display: none; /* For Chrome, Safari, and Edge */
    }
    .drawer-content {
        -ms-overflow-style: none; /* For Internet Explorer and Edge */
        scrollbar-width: none; /* For Firefox */
    }
	.contact_tooltip {
        font-size: .8rem !important;
        padding: .25rem .8rem !important;
        margin-top: .2rem !important;
    }
    .bordered_block { 
        /* rounded corners, with a background color and padding to separate it from other sections */
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
        border: 1px solid #ccc;
        background-color: #fcfcfc;
        padding: 8px;
    }
</style>


// WEBPACK FOOTER //
// src/components/EmpFilingData.vue